module.exports = __webpack_public_path__ + "static/media/onboarding-trivia-final.c4fb6003.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-trivia-final.png
// module id = 2709
// module chunks = 0